package one.healthium.pcos.presentation.navigation.log_period

import androidx.compose.runtime.Composable
import one.healthium.log_period.ui.LogPeriodScreen


@Composable
fun LogPeriodContent(component: LogPeriodComponent) {
    LogPeriodScreen(component)
}